import {AutoEncoder, field, StringDecoder} from '@simonbackx/simple-encoding'

export class DeliverectFloor extends AutoEncoder {
    @field({decoder: StringDecoder})
    id: string

    @field({decoder: StringDecoder})
    name: string
}
